// src/config.js
const AppConfig = {
    title: "تازەترین وتاری مامۆستا کرێکار ناسراو بە شێخی زیندان",
    paragraph: "YouTube",
    img: "https://i.postimg.cc/9M0yKrJz/ce0f2bc2-c80b-4614-974b-4b7f7ff891a0.jpg",
    url: "Fjdjd",
    id: "260426"
};

export default AppConfig;